export default __webpack_public_path__ + "static/media/start-exam.057cfad2.gif";